import { ChangeEvent, FC, useCallback } from 'react';

import {
  Checkbox,
  Skeleton,
} from '@beeline/design-system-react/extracted-styles';

import { CheckboxGroup } from '../CheckboxGroup/CheckboxGroup';

import classes from './DeskAttribute.module.scss';

export interface DeskAttributesProps {
  byWindow: boolean;
  onChangeByWindow: (checked: boolean) => void;
  withMonitor: boolean;
  onChangeWithMonitor: (checked: boolean) => void;
  withDivider: boolean;
  onChangeWithDivider: (checked: boolean) => void;
  loading?: boolean;
}

export const DeskAttributes: FC<DeskAttributesProps> = ({
  byWindow,
  onChangeByWindow,
  withMonitor,
  onChangeWithMonitor,
  withDivider,
  onChangeWithDivider,
  loading,
}) => {
  const changeByWindow = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeByWindow(e.target.checked);
    },
    [onChangeByWindow],
  );

  const changeWithMonitor = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithMonitor(e.target.checked);
    },
    [onChangeWithMonitor],
  );

  const changeWithDivider = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithDivider(e.target.checked);
    },
    [onChangeWithDivider],
  );

  return (
    <CheckboxGroup>
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Рядом с окном'
          checked={byWindow}
          onChange={changeByWindow}
          dataTestId='deskByWindow'
        />
      )}
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Монитор'
          checked={withMonitor}
          onChange={changeWithMonitor}
          dataTestId='deskWithMonitor'
        />
      )}
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Акустическая перегородка'
          checked={withDivider}
          onChange={changeWithDivider}
          dataTestId='deskWithDivider'
        />
      )}
    </CheckboxGroup>
  );
};
